<div class=" flex flex-column align-items-center justify-content-center text-xl font-light align-self-center">
  <h1 class="font-light">Benvenuto su</h1>
  <img class="rotate-center h-18rem w-18rem" src="assets/svg/flower.svg">
  <h1 class="font-light">{{loggedUser?.shownAppName ?? "FLOWEERS" }}</h1>
</div>
